import { usePagePreload, type PagePreloadStatus } from './PagePreloadProvider';
import type { PagePreloadKey } from './registry';

/**
 * Hook to get the status of a specific page preload.
 *
 * Use this in pages that need preloading to determine whether to show
 * the empty/onboarding state or the list view.
 *
 * @example
 * ```tsx
 * const IPPoolsPage = () => {
 *   const { hasItems, isLoading } = usePagePreloadStatus('ipPools');
 *
 *   // No loading state needed - we already know!
 *   if (!hasItems) {
 *     return <EmptyState />;
 *   }
 *
 *   return <IPPoolsList />;
 * };
 * ```
 */
export const usePagePreloadStatus = (
	key: PagePreloadKey,
): PagePreloadStatus => {
	const { getStatus } = usePagePreload();

	return getStatus(key);
};

export default usePagePreloadStatus;
